import React, {useEffect, useState} from 'react'
import './InviteCard.scss'
import {withRouter} from 'react-router-dom';
import {Zoom, Fade} from 'react-reveal'
import {assetUrl} from "../../serviceApi";
import {fetchQuery} from "relay-runtime";
import environment from "../../Environment";
import UpcommingStocksQuery from "../../queries/UpcommingStocksQuery";
import {NonEmptyArray} from "../../util";
import ReferalBonusQuery from "../../queries/ReferalBonusQuery";
import {connect} from "react-redux";
import Login from "../../pages/Login/Login";

const linkArrow = assetUrl+'images/arrow-right-white-sm.svg'
const bgPattern = assetUrl+'images/invite_bg1.png'
const illustration_coinBlur = assetUrl+'images/inviteCard-coin-blur.png'
const illustration_speaker = assetUrl+'images/inviteCard-speaker1.png'
const illustration_man = assetUrl+'images/Illustration_Invite_friends.png'
const illustration_coin = assetUrl+'images/animation_inviteCard_coin.svg'
const illustration_mail = assetUrl+'images/animation_inviteCard_mail.svg'

const InviteCard = (props) => {
	const styleInvite = "invitecard-"
	const [bonus_value, setBonus_value] = useState("");
	const [login_modal, setLoginModal] = useState(false);

	useEffect(() => {
		getReferalBonus()
		// return () => {
		// 	effect
		// };
	}, []);


	const getReferalBonus = () => {

		// this.updateLoading(true);
		fetchQuery(environment, ReferalBonusQuery)
			.toPromise()
			.then(response => {

				if (response.joiningBonus && response.joiningBonus.edges[0] ) {
					setBonus_value(response.joiningBonus.edges[0].node.value)

				} else {
					setBonus_value("")
					// this.updateLoading(false);
				}

			}, err => {
				console.log(err);
				setBonus_value("")
			});
	}
	const checkUserLoggedIn = () => {
		if(props.logged_in === false){
			openLoginModal();
		} else  {
			props.history.push("/invite");
		}
	}
	const openLoginModal = () => {
		setLoginModal(true);
	}
	const closeLoginModal = () => {
		setLoginModal(false);
	}
	const completeLogin = () => {
		closeLoginModal();
		window.location.reload();
	}

	return (
		<>
			<div className={styleInvite + "main d-flex justify-content-between align-items-end"}>
			<img src={bgPattern} alt={"alt"} className={styleInvite+"bg-pattern"}/>
			<div>
				<p className={styleInvite + "text "}>Invite Friends<br/> & Earn Upto <br/><span style={{fontWeight: 800}}> ₹ {bonus_value !== ""?bonus_value:0} in Bonus</span></p>
				{/*<p className={styleInvite + "para"}>Lorem ipsum dolor sit amet, consectetur tellus commodo tellus haeuds*/}
				{/*	adipiscing elit.</p>*/}
				<button className={styleInvite + "link d-flex align-items-center"} onClick={() => checkUserLoggedIn()}>
					<p className={"mb-0"}>Invite Now</p>
					<img src={linkArrow} alt={"alt"} className={styleInvite + "icon"} style={{marginLeft:"6px"}}/>
				</button>
			</div>
			<div className={styleInvite + "image-wrap"}>
				<div className={styleInvite + "image-man"}><Fade delay={700} distance={"20px"} bottom><img
					src={illustration_man} alt={"alt"}/></Fade></div>
				<div className={styleInvite + "image-coin"}><Zoom delay={1000}><img src={illustration_coin}
				                                                                    alt={"alt"}/></Zoom></div>
				<div className={styleInvite + "image-mail"}><Zoom delay={1000}><img src={illustration_mail}
				                                                                    alt={"alt"}/></Zoom></div>
				<div className={styleInvite + "image-coin-blur"}><Zoom delay={1000}><img src={illustration_coinBlur}
				                                                                    alt={"alt"}/></Zoom></div>
				<div className={styleInvite + "image-speaker"}><Zoom delay={1000}><img src={illustration_speaker}
				                                                                    alt={"alt"}/></Zoom></div>
			</div>
		</div>
			<Login isOpen={login_modal}
				   closeModal={closeLoginModal}
				   completeLogin={completeLogin}
			/>
		</>
	)
}


const mapStateToProps = state => ({
	logged_in: state.UserReducer.logged_in
});

export default connect(mapStateToProps)(withRouter(InviteCard))
